import { useDeleteMemberMutation } from '../hooks/useDeleteMemberMutation'
import { useMembersStore } from '../store/membersStore'
import type { ApiError } from '@/types/api'
import { Modal } from '@/components/custom/modal'
import LoadingButton from '@/components/custom/loading-button'
import { notifyRequestError } from '@/utils/notifyRequestError'

export function DeleteMember({
  id,
  trigger,
  open,
  onClose,
}: {
  id: string | null
  trigger?: React.ReactNode
  open?: boolean
  onClose?: () => void
}) {
  const { mutateAsync: deleteMemberMutation, isPending } =
    useDeleteMemberMutation()

  const members = useMembersStore((s) => s.members)
  const member = members.find((u) => u._id === id)

  const handleDeleteMember = async () => {
    if (!member) return

    try {
      await deleteMemberMutation(member._id)
      onClose?.()
    } catch (error) {
      notifyRequestError(error as ApiError, 'Failed to delete member')
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      trigger={trigger}
      title="Delete Member"
    >
      <div className="space-y-4">
        <p>
          Are you sure you want to delete member <strong>{member?.name}</strong>
          ?
          <br />
          <span className="text-red-500 font-semibold">
            This action is permanent and cannot be undone.
          </span>
        </p>
        <LoadingButton
          type="submit"
          className="w-full"
          isLoading={isPending}
          disabled={isPending}
          onClick={handleDeleteMember}
        >
          {isPending ? 'Deleting...' : 'Delete'}
        </LoadingButton>
      </div>
    </Modal>
  )
}
